import React from "react";
import Mesh from "../../assets/images/BGmesh2.svg";
import computer from "../../assets/images/Computer.png";

const Section5 = () => {
  return (
    <section
    className="tw-max-w-[100vw] tw-bg-[15rem_0] tw-bg-[length:100vw] tw-bg-no-repeat" id="requestdemo"
    style={{ backgroundImage: `url(${Mesh})` }}
  >
    <div className="tw-flex tw-items-center tw-mx-7 lg:tw-mx-10 xl:tw-mx-14 2xl:tw-mx-32 tw-px-7 2xl:tw-px-12 tw-py-8 tw-justify-center lg:tw-justify-between">
      <img className="tw-max-lg:hidden tw-w-[calc(100%-555px)] tw-max-w-[617px]" src={computer} alt="" srcSet="" />
      <div className="tw-w-fit tw-max-w-[550px] tw-py-4 md:tw-py-8 tw-px-6 md:tw-px-12 max-md:tw-pb-8 tw-bg-[#662d91] tw-text-white">
        <div>
          <h1 className="tw-text-2xl tw-tracking-[0.015em] ProductSansMedium">
            Almost there to get your Demo Account!
          </h1>
          <h3 className="tw-mt-2 tw-text-[15px] ProductSansLight tw-leading-[1.2]">
            Fill the form below to get connected with our ERP expert
            <br /> to experience the Live Demo.
          </h3>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-7 tw-text-xs ProductSansLight">
          <div className="tw-flex tw-gap-3 xs:tw-gap-7 max-xs:tw-flex-col">
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="text"
              name="firstName"
              placeholder="First Name *"
              id=""
            />
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="text"
              name="lastName"
              placeholder="Last Name *"
              id=""
            />
          </div>
          <div className="tw-flex tw-gap-3 xs:tw-gap-7 max-xs:tw-flex-col">
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="text"
              name="companyName"
              placeholder="Company Name *"
              id=""
            />
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="email"
              name="workEmail"
              placeholder="Work Email *"
              id=""
            />
          </div>
          <div className="tw-flex tw-gap-3 xs:tw-gap-7 max-xs:tw-flex-col">
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="tel"
              name="phoneNumber"
              placeholder="Phone Number *"
              id=""
            />
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="text"
              name="country"
              placeholder="Country (India)"
              id=""
            />
          </div>
          <div className="tw-flex tw-gap-3 xs:tw-gap-7 max-xs:tw-flex-col">
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="text"
              name="pinCode"
              placeholder="P.O Box / Postal Code"
              id=""
            />
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="text"
              name="designation"
              placeholder="Designation"
              id=""
            />
          </div>
          <div className="tw-flex tw-gap-3 xs:tw-gap-7 max-xs:tw-flex-col">
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="text"
              name="aboutUs"
              placeholder="How did you hear about us?"
              id=""
            />
            <input
              className="tw-border-b-[1px] tw-p-1 tw-px-2 tw-mx-auto tw-w-4/5 xs:tw-w-full tw-bg-transparent tw-placeholder:text-white tw-outline-none"
              type="text"
              name="usersRequired"
              placeholder="Number of User’s Required"
              id=""
            />
          </div>
        </div>
        <div className="tw-flex tw-gap-2 tw-mt-10">
          <div className="tw-border-[1px] tw-border-white tw-bg-white tw-w-6 tw-h-5 tw-flex tw-justify-center tw-items-center">
            <input
              className="tw-w-5 tw-h-4 tw-opacity-0 checked:tw-opacity-100 tw-outline-none tw-accent-white tw-cursor-pointer"
              type="checkbox"
              name=""
              id=""
            />
          </div>
          <p className="tw-leading-[1.25] tw-text-[10px] ProductSansLight mt-0">
            By filling and submitting this form you understand and agree that
            the use of Finanzz web site is subject to the Finanaz.in{" "}
            <span className="tw-text-[#29A2D5] ProductSansMedium">Terms of Use</span>. Additional
            details regarding Finanzz collection and use of your personal information, including information about access,
            retention, rectification, deletion, security, cross-border transfers and other topics, is available in the Finanzz{" "}
            <span className="tw-text-[#29A2D5] ProductSansMedium">Privacy Policy</span>.
          </p>
        </div>
        <div className="tw-flex tw-justify-center tw-mt-8">
          <button className="tw-text-sm tw-px-10 tw-py-[10px] ProductSansBold tw-tracking-tight tw-text-black tw-bg-[#ffffff] hover:tw-bg-[#FDD60E] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-duration-500 tw-ease-in-out hover:tw--translate-y-[2px] active:tw-translate-y-3 focus:tw-outline-none">
            REQUEST DEMO
          </button>
        </div>
      </div>
    </div>
  </section>
  
  );
};

export default Section5;
